import {createContext} from "@lit/context";
import type {BridgeBarDataContextValue} from "./BridgeBarData";

export const BridgeBarDataContext = createContext<BridgeBarDataContextValue>(
  "bridge-bar-data-context"
);
